import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

const LoadingSpinner = () => (
    <div className="text-center text-info my-5">
        <FontAwesomeIcon icon="spinner" pulse size="6x" />
    </div>
);

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.js